import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function AuthenticatedImage({ src, alt, className, onError, fallback = null }) {
  const [objectUrl, setObjectUrl] = useState('');

  useEffect(() => {
    let isMounted = true;
    let nextObjectUrl = '';

    const load = async () => {
      if (!src) {
        setObjectUrl('');
        return;
      }

      try {
        const response = await axios.get(src, { responseType: 'blob' });
        nextObjectUrl = URL.createObjectURL(response.data);
        if (isMounted) {
          setObjectUrl(nextObjectUrl);
        }
      } catch (error) {
        if (isMounted) {
          setObjectUrl('');
          if (onError) {
            onError(error);
          }
        }
      }
    };

    load();

    return () => {
      isMounted = false;
      if (nextObjectUrl) {
        URL.revokeObjectURL(nextObjectUrl);
      }
    };
  }, [src, onError]);

  if (!objectUrl) {
    return fallback;
  }

  return <img src={objectUrl} alt={alt} className={className} />;
}
